import { NormalizedNumber } from '@sparkdotfi/common-universal'
import BigNumber from 'bignumber.js'

import { Token } from '@/domain/types/Token'
import { TransactionOverview } from '@/ui/organisms/transaction-overview/TransactionOverview'

export interface CollateralOverviewPanelProps {
  collateral: Token
  collateralBalance: NormalizedNumber
  currentHealthFactor?: BigNumber
  updatedHealthFactor?: BigNumber
}
export function CollateralOverviewPanel({
  collateral,
  collateralBalance,
  currentHealthFactor,
  updatedHealthFactor,
}: CollateralOverviewPanelProps) {
  return (
    <TransactionOverview>
      <TransactionOverview.Row>
        <TransactionOverview.Label>Deposit balance</TransactionOverview.Label>
        <TransactionOverview.TokenAmount token={collateral} amount={collateralBalance} />
      </TransactionOverview.Row>
      <TransactionOverview.Row>
        <TransactionOverview.Label>Health factor</TransactionOverview.Label>
        <TransactionOverview.HealthFactorChange
          currentHealthFactor={currentHealthFactor}
          updatedHealthFactor={updatedHealthFactor}
        />
      </TransactionOverview.Row>
    </TransactionOverview>
  )
}
